// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"9c632c1b01cafd737664","655":"381a87f5774ac01465e7"}[chunkId] + ".js";
};